import { downgradeComponent } from '@angular/upgrade/static';
import { ReportWidgetComponent, ReportWidgetEditComponent } from '@fry-it/risr-features/reports';

(function() {
  'use strict';

  function SQLReportWidgetViewController(
    config,
    Users
  ) {
    var ctrl = this;

    ctrl.config = config;
    ctrl.config.test = 'test';
    ctrl.username = Users.remoteUser || '__own__';
  }

  SQLReportWidgetViewController.$inject = [
    'config',
    'UsersService'
  ];

  function SQLReportWidgetEditController($scope, config) {
    var ctrl = this;

    ctrl.config = config;
    $scope.config = config;

    ctrl.configChange = function(config) {
      console.log(config);
      _.assign($scope.config, config);
    };
  }

  SQLReportWidgetEditController.$inject = [
    '$scope',
    'config'
  ];

  function config(dashboardProvider) {
    dashboardProvider.widget('SQLReportWidget', {
      title: 'Report',
      description: 'Displays a report',
      controller: 'SQLReportWidgetViewController',
      controllerAs: 'viewCtrl',
      templateUrl: 'app/components/sqlreports/widgets/sqlreport/view.html',
      reload: true,
      edit: {
        templateUrl: 'app/components/sqlreports/widgets/sqlreport/edit.html',
        controller: 'SQLReportWidgetEditController',
        controllerAs: 'editCtrl'
      },
      category: 'Reports'
    });
  }

  config.$inject = ['dashboardProvider'];

  angular.module('component.sqlreports')
    .config(config)

    .directive('sqlReportWidget', downgradeComponent({
      component: ReportWidgetComponent,
      inputs: ['config', 'username']
    }))
    .directive('sqlReportWidgetEdit', downgradeComponent({
      component: ReportWidgetEditComponent,
      inputs: ['config'],
      outputs: ['configChange']
    }))
    .controller('SQLReportWidgetViewController', SQLReportWidgetViewController)
    .controller('SQLReportWidgetEditController', SQLReportWidgetEditController);
})();
